import React from "react";
import { Modal } from "react-bootstrap";
import { ApplicationState } from "../../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { connect, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { changeIntGroupAssigmentCollapsedSettings, checkAllStudentsHaveDiagnosticInfo, hideConfirmRecommendModal, openConfirmRecommendModal } from "../../../../../../store/onboarding/actions";
import { AllStudentsHaveDiagnosticInfo, DataPeriod, EvidenceData, EvidencePeriodData } from "../../../../../../store/onboarding/types";
import { activeTabUrl, openGroupRecommendationFromData } from "../../../../../../store/onboarding/cases/actions";
import { CoachDashboardTabKeys } from "../../../../../pages/coach-dashboard/CoachDashboard";
import useActiveTab from "../../../../../pages/parent-dashboard/useActiveTab";
import { toastr } from "react-redux-toastr";

type PropsFromState = {
  showModal: boolean;
  currentDataPeriod?: DataPeriod;
  hasAcademic?: boolean;
  hasBehavior?: boolean;
  evidencePeriodData?: EvidencePeriodData
};

type DispatchProps = {
  hideConfirmRecommendModal: () => any;
  push: (location: string) => any;
  activeTabUrl: (tabName:string) =>any;
  openGroupRecommendationFromData: () => void;
  changeIntGroupAssigmentCollapsedSettings: (collapseSettting: any) => void;
  checkAllStudentsHaveDiagnosticInfo: () => any;
  openConfirmRecommendModal: (hasAcademic?: boolean, hasBehavior?: boolean) => any;
};

const useActiveTabWrapper = (Component:any) => (props:Props) => {
  const {changeActiveTab} = useActiveTab()
  return <Component {...props} changeActiveTab={changeActiveTab} />;
};
type Props = PropsFromState & DispatchProps;

const RECOMMENDATIONS_ASSIGMENT_ID = -999; // just some uniq value to store in locale storage
class ConfirmRecommendModal extends React.Component<any, any> {
  constructor(props:Props) {
    super(props);
  }
  
  handleYes = (queryStr:string = '') => {
    this.props.activeTabUrl(queryStr);
    if(queryStr == 'groups/behavior') {
      this.props.push('/cases/'+ CoachDashboardTabKeys.YOUR_BEHAVIOUR_ASSIGNMENTS + '?tab=active');
      this.props.changeActiveTab(CoachDashboardTabKeys.YOUR_BEHAVIOUR_ASSIGNMENTS)
    } else {
      this.props.checkAllStudentsHaveDiagnosticInfo()
      .then((isAllStudentsHaveDiagnosticInfo: AllStudentsHaveDiagnosticInfo) => { 
        if (isAllStudentsHaveDiagnosticInfo.show_message_students_needing_intervention) {
          this.props.hideConfirmRecommendModal();
          this.props.openConfirmRecommendModal(this.props.hasAcademic);
        } else {
          this.props.push('/cases/'+ CoachDashboardTabKeys.YOUR_READING_ASSIGNMENTS + '?tab=active');
          this.props.changeActiveTab(CoachDashboardTabKeys.YOUR_READING_ASSIGNMENTS)
        }
      }, (err: string) => toastr.error("Failed!!", err));

    }
    this.props.openGroupRecommendationFromData();
    
    this.props.hideConfirmRecommendModal();
  };

  render() {
    const { showModal } = this.props;
    return (
      <Modal
        show={showModal}
        onHide={this.props.hideConfirmRecommendModal}
        animation={false}
        backdropClassName="customDarkModalBackdrop in"
        centered
      >
        <Modal.Header
          closeButton
          className={`purpleModalHeader font-weight-bold`}
        >
          <Modal.Title> {this.props.hasBehavior && this.props.hasAcademic ? 'Select Group Type': 'Missing Diagnostic Data'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.hasBehavior && this.props.hasAcademic ?
          <>
          <div className="text-center mb-3">
            <p className="font-weight-bold">Which group type would you like to view?</p>
            <p>Your data period contains both <strong>Behavior</strong> and <strong>Reading</strong> data.</p>
          </div>
          <hr/>
          <div className="d-flex justify-content-between">
            <button
              className="whiteBtnSm"
              onClick={this.props.hideConfirmRecommendModal}
            >
              Cancel
            </button>
            <div className="text-right">
              <button className="blueBtnSm mr-2" onClick={() => this.handleYes('groups/behavior')}>
                Behavior Groups
              </button>
              <button className="blueBtnSm" onClick={() => this.handleYes('groups/reading')}>
                Reading Groups
              </button>
            </div> 
          </div>
          </>
          :
          <>
            <div className="text-center mb-3">
              <p className="font-weight-bold">Are you sure you want to continue?</p>
              <p> Some students identified as needing intervention do not have diagnostic data.</p>
            </div>
            <hr/>
            <div className="d-flex justify-content-between">
              <button
                className="whiteBtnSm"
                onClick={this.props.hideConfirmRecommendModal}
              >
                Cancel
              </button>
              <button className="blueBtnSm ml-2" onClick={() => {
                  this.props.push('/cases/'+ CoachDashboardTabKeys.YOUR_READING_ASSIGNMENTS);
                  this.props.changeActiveTab(CoachDashboardTabKeys.YOUR_READING_ASSIGNMENTS);
                  this.props.openGroupRecommendationFromData();
                  this.props.hideConfirmRecommendModal();
              }}>
                Continue
              </button>
            </div>
          </>
          }
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = ({ onboarding }: ApplicationState): PropsFromState => {
  return {
    showModal: onboarding.modalsState.confirmRecommendModal,
    currentDataPeriod: onboarding.currentDataPeriod,
    hasBehavior: onboarding.modalsState.hasBehavior,
    hasAcademic: onboarding.modalsState.hasAcademic,
    evidencePeriodData: onboarding.evidencePeriodData
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      hideConfirmRecommendModal: hideConfirmRecommendModal,
      push: push,
      activeTabUrl: activeTabUrl,
      openGroupRecommendationFromData: openGroupRecommendationFromData,
      changeIntGroupAssigmentCollapsedSettings: changeIntGroupAssigmentCollapsedSettings,
      checkAllStudentsHaveDiagnosticInfo: checkAllStudentsHaveDiagnosticInfo,
      openConfirmRecommendModal: openConfirmRecommendModal
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(useActiveTabWrapper(ConfirmRecommendModal));
